import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/user/sales-developers";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/user/dropdown/SalesDeveloper";
const exportApi =API_BASE_URL_ENV() + "/admin/user/sales-developers?seller=1&export=1"

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    toggleStatus=(id)=>{ 
        return http.get(`${API_BASE_URL_ENV()}/admin/user/toggle-activation/SalesDeveloper/${id}`)   
    }
   
    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
    }

    invite(data) {
        return http.post(`${API_BASE_URL_ENV()}/admin/user/sales-developer/invite`, data);
    }

    getExportUrl = (active,searchWord) =>{
        const obj = JSON.parse(localStorage.getItem("auth"))
        let url = `${exportApi}&token=${obj.access_token}`;
        if (active != 'all')  url =url + `&status=${active === "active" ? 1 : 0}`;
        // if (searchWord.trim().length)  url =url + `&keyword=${searchWord}`;
        return url
    }
}
